import React, { Component } from "react";

import DateTimePicker from "./DateTimePicker";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import "moment/locale/de";

export default class DatePicker extends Component {
  defaultFormat = "DD-MM-YYYY";

  getValueFormat() {
    const { props } = this;
    return props.valueFormat || props.inputFormat || this.defaultFormat;
  }

  getInputFormat() {
    const { props } = this;
    return props.inputFormat || this.defaultFormat;
  }

  getDisplayFormat() {
    const { props } = this;
    if (props.displayFormat) {
      return props.displayFormat;
    }
    const { value } = props;

    const valueFormat = this.getValueFormat();
    const isThisYear =
      value && moment(value, valueFormat, true).year() === moment().year();
    return isThisYear ? "dd D MMM" : "dd D MMM YYYY";
  }

  render() {
    const {
      label,
      name,
      placeholder,
      locale = "en-gb",
      value,
      readOnly,
      disabled,
      minDate,
      maxDate,
      invalidDate,
    } = this.props;

    moment.locale(locale);
    const valueFormat = this.getValueFormat();
    const inputFormat = this.getInputFormat();
    const displayFormat = this.getDisplayFormat();
    return (
      <DateTimePicker
        label={label}
        name={name}
        value={value}
        minDate={minDate}
        maxDate={maxDate}
        valueFormat={valueFormat}
        inputFormat={inputFormat}
        displayFormat={displayFormat}
        placeholderText={placeholder}
        locale={locale}
        //className="react-datepicker"
        readOnly={readOnly} //Todo: Select all on focus to clear all. {this.props.inputIsReadOnly || false}
        disabled={disabled}
        aria-required={!!this.props["aria-required"]}
        invalidDate={invalidDate}
        //hasIndicator={false}
        //disabledKeyboardNavigation={true}
        //isClearable={true}
        //calendarClassName="calendar"
        //dayClassName={date => "calendar__day"}
        //popperClassName="calendar__popper"
        highlightWithRanges={[
          {
            "react-datepicker__day--highlighted": [
              moment(), //today
            ],
          },
        ]}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/DatePicker.js